module.exports = __webpack_public_path__ + "TB_Eating_SFX_A.wav.e10d45f4.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_SFX_A.wav.mp3
// module id = 494
// module chunks = 0